var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3753 9.5835V20.1252L9.58366 17.2502L4.79199 20.1252V9.5835C4.79199 8.821 5.09489 8.08973 5.63406 7.55056C6.17323 7.0114 6.90449 6.7085 7.66699 6.7085H11.5003C12.2628 6.7085 12.9941 7.0114 13.5333 7.55056C14.0724 8.08973 14.3753 8.821 14.3753 9.5835Z",
    stroke: "#4F287A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.542 2.875H15.3337C16.0962 2.875 16.8274 3.1779 17.3666 3.71707C17.9058 4.25624 18.2087 4.9875 18.2087 5.75V16.2917",
    stroke: "#4F287A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.f043ddca0b5369c0ad6b8c330466662a.svg";
export { ForwardRef as ReactComponent };